module.exports = __webpack_public_path__ + "img/law-serve-nav-icon06.1edbf58d.png";